import { Box, Stack, styled } from '@mui/material';
import { ComponentProps } from 'react';
import { LoadingButton } from 'components';

export const ResultContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(6),
  },
  [theme.breakpoints.up('md')]: {
    overflowY: 'scroll',
  },
}));

export const StyledBundleResults = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(4),
}));

export const PromptResultContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '&:last-child': {
      marginBottom: theme.spacing(10),
    },
  },
}));

export const PreloaderContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(3),
}));

export const StyledButtonBase = styled(LoadingButton)(() => ({
  alignSelf: 'center',
}));

export const StyledButton = (
  props: ComponentProps<typeof StyledButtonBase>
) => <StyledButtonBase variant="outlined" {...props} />;
